import Navigator from './Navigator';
export default Navigator;
